import React from "react";
import Layout from "@/components/Layout";
import { UpsellsCard, PortalBrandingCard, GuidebookOrderCard } from "@/pages/Settings";
import { UpsellSalesCard } from "@/components/GrowthCards";

export default function GuestPortal() {
  return (
    <Layout title="Guest Portal" subtitle="Everything guests see after booking — extras they can buy, branding and section order.">
      <div className="space-y-6 max-w-4xl" data-testid="guest-portal-page">
        <UpsellSalesCard />
        <UpsellsCard />
        <PortalBrandingCard />
        <GuidebookOrderCard />
      </div>
    </Layout>
  );
}
